import { useContext, useEffect, useState } from 'react';
import {
  Alert,
  Fab,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';

import {
  DriveFileMove as DriveFileMoveIcon,
} from '@mui/icons-material';

import { getDatabase, ref, onValue } from "firebase/database";
import { AuthContext } from 'components';

const db = getDatabase();

export const MoveModal = (props) => {
  const { items, selected } = props;
  const [ open, setOpen ] = useState(false);
  const [ saving, setSaving ] = useState(false);
  const [ seasonLimit, setSeasonLimit ] = useState(3);
  const { moveItem, account, seasons, selectedStore, selectedSeason, selectedCollection, sortByDisplayOrder, notify } = useContext(AuthContext)
  const [ localCollections, setLocalCollections ] = useState([])
  const [ newStore, setNewStore ] = useState(selectedStore)
  const [ newSeason, setNewSeason ] = useState(selectedSeason)
  const [ newCollection, setNewCollection ] = useState(selectedCollection)

  useEffect(() => {
    if (Object.keys(seasons).sort((a, b) => seasons[b].displayOrder - seasons[a].displayOrder).slice(0, seasonLimit).indexOf(selectedSeason) === -1) {
      setSeasonLimit(Object.keys(seasons).length);
    }
  }, [])

  useEffect(() => {
    const collections_ref = ref(db, 'accountCollections/' + newStore + '/' + newSeason);
    onValue(collections_ref, (snapshot) => {
      const data = snapshot.val() || [];
      setLocalCollections({
        'all': { displayName: 'No Collection' },
        ...data
      })
    })
  }, [newStore, newSeason])

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
  }

  const handleAction = () => {
    if (!selected) {
      return
    }

    let bulk_action = []

    items.forEach((item) => {
      bulk_action.push(new Promise((resolve, rejejct) => {
        moveItem({
          ...item,
          collectionId: newCollection !== 'all' ? newCollection : null
        }, { store: newStore, season: newSeason }, resolve)
      }))
    })

    Promise.all(bulk_action).then(() => {
      handleClose()
      notify({
        message: `${items.length} product(s) moved to ${account.acctStores[newStore].displayName}/${seasons[newSeason].displayName}`
      })
    })
  };
 
  return (
    <Fab disableRipple component="div" disabled={!selected} color="secondary" aria-label="move">
      <DriveFileMoveIcon onClick={handleOpen} />
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>
          Choose where you want to move {items.length} {`item${items.length > 1 ? 's' : ''}`}
        </DialogTitle>
        <DialogContent>
          { selectedStore === newStore && selectedSeason === newSeason && selectedCollection === newCollection && newCollection !== 'all' ? (
            <Alert variant="outlined" severity="info">
              Please select a different destination to move { items.length > 1 ? 'these products' : 'this product' } to
            </Alert>
          ) : null}
          <DialogContentText sx={{ textAlign: 'center' }}>
            {/* Store selection */}
            <FormControl fullWidth variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={newStore}
                onChange={(e) => setNewStore(e.target.value)}
                label="Store"
              >
                {Object.keys(account.acctStores).map((s) => <MenuItem key={`store-${account.acctStores[s].displayName}`} value={s}>{account.acctStores[s].displayName}</MenuItem>)}
              </Select>
            </FormControl>
            {/* Season selection */}
            <FormControl fullWidth variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={newSeason}
                onChange={(e) => setNewSeason(e.target.value)}
                label="Season"
              >
                {Object.keys(seasons).sort((a, b) => seasons[b].displayOrder - seasons[a].displayOrder).slice(0, seasonLimit).map((s) => <MenuItem key={`season-${seasons[s].displayName}`} value={s}>{seasons[s].displayName}</MenuItem>)}
                {seasonLimit === 3 && <MenuItem onClickCapture={(e) => { setSeasonLimit(Object.keys(seasons).length); e.stopPropagation(); }} key={`season-show-more`} value={'show_more'}>Show more</MenuItem>}
              </Select>
            </FormControl>
            {/* Collection selection */}
            <FormControl fullWidth variant="standard" sx={{ m: 1, minWidth: 120 }}>
              <Select
                value={newCollection}
                onChange={(e) => setNewCollection(e.target.value)}
                label="Collection"
              >
                {Object.keys(localCollections).map(e => ({ ...localCollections[e], id: e })).sort(sortByDisplayOrder).map((s) => <MenuItem key={`collection-${s.displayName}`} value={s.id}>{s.displayName}</MenuItem>)}
              </Select>
            </FormControl>
          </DialogContentText>
          
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={() => { setSaving(true); setTimeout(handleAction, 200) }} autoFocus disabled={selectedStore === newStore && selectedSeason === newSeason && selectedCollection === newCollection && newCollection !== 'all'}>Move</Button>
        </DialogActions>
      </Dialog>
    </Fab>
  )
}